/** Validators shared by the forms. */

// Email pattern of the store and user forms, written as its
// named parts: a dotted local part or a quoted one, then an IPv4 address in
// brackets or a dotted domain name with an alphabetic top-level domain.
const LOCAL_ATOM = String.raw`[^<>()[\]\\.,;:\s@"]+`;
const LOCAL_PART = String.raw`(${LOCAL_ATOM}(\.${LOCAL_ATOM})*)|(".+")`;
const IP_DOMAIN = String.raw`\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}]`;
const NAMED_DOMAIN = String.raw`([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}`;

export const EMAIL_PATTERN = new RegExp(
  `^(${LOCAL_PART})@((${IP_DOMAIN})|(${NAMED_DOMAIN}))$`,
);

export const isEmail = (value: string): boolean => EMAIL_PATTERN.test(value);
